<template>
  <CDropdown variant="nav-item">
    <CDropdownToggle placement="bottom-end" class="py-0" :caret="false">
      <CAvatar :src="avatar" size="md" />
    </CDropdownToggle>
    <CDropdownMenu class="pt-0">
     <!-- <CDropdownItem> <CIcon icon="cil-user" /> Profile </CDropdownItem>
      <CDropdownItem> <CIcon icon="cil-settings" /> Settings </CDropdownItem>-->
      <CDropdownItem @click="logout" class="cursor-pointer">
        <CIcon icon="cil-lock-locked" /> Logout
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import avatar from '@/assets/brand/logo3.png'
import axios from '/src/axios'
export default {
  name: 'AppHeaderDropdownAccnt',
  data() {
    return {
      avatar: avatar,
    }
  },

  methods: {
    logout() {
      axios
        .post('logout')
        .then(() => {
          localStorage.removeItem('token');
          window.location.href = "/";
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>
